if (window.location.pathname !== "/delete-account") {
  window.location.replace("/delete-account");
}
